module.exports = __webpack_public_path__ + "img/building-line-trans.b882e6b2.svg";